import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Trophy } from 'lucide-react'

interface NoBracketsCardProps {
  canManageGroup: boolean
  onActivateBrackets: () => void
}

export function NoBracketsCard({
  canManageGroup,
  onActivateBrackets,
}: NoBracketsCardProps) {
  return (
    <Card>
      <CardContent className="py-8 text-center">
        <Trophy className="h-10 w-10 mx-auto mb-3 text-muted-foreground" />
        <h3 className="font-semibold mb-2">No Brackets Yet</h3>
        <p className="text-sm text-muted-foreground">
          This season doesn't have any brackets activated yet.
        </p>
        {canManageGroup && (
          <Button 
            variant="outline" 
            className="mt-4"
            onClick={onActivateBrackets}
          >
            Activate Brackets
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
